<template>
  <div class="u-wrap">
    <div class="sqq-heard">
      <div class="home-pic">
        <img src="@images/gzfw/camera.png" class="camera" style="" m @click="goPublish" />
        <div class="home-pic-base">
          <div class="top-pic">
            <img v-if="userImage" class="header" :src="userImage" />
            <img v-else class="header" src="@images/headerDft.png" />
          </div>
          <div class="top-name">{{ realname }}</div>
          <div class="top-desc">{{ orgCodeName }}</div>
        </div>
      </div>
    </div>

    <div class="u-menu-wrap">
      <van-empty v-if="dataList.length == 0" description="暂无数据" />
      <van-pull-refresh v-else v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" offset="20" :finished="finished" :finished-text="finishedTxt" @load="onLoad">
          <div style="width: 100vw">
            <sqq-list :list="dataList" isDel :realname="realname"></sqq-list>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { getAction, postAction } from '@/api/manage'
import Vue from 'vue'
import { OPEN_ID, SYS_ORGCODE, WX_USER, ACCESS_TOKEN, APPID } from '@/store/mutation-types'
import sqqList from '@/views/common/sqq-list.vue'
export default {
  components: { sqqList },
  data() {
    return {
      current: 0, // 预设当前项的值
      keyword: '',
      dataList: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 0,
      finishedTxt: '',

      userImage: '',
      realname: '',
      orgCodeName: '',
      sysOrgCode: '',
      username:'',
    }
  },
  created() {
    this.initInfo()
    this.getOrgCode()
    this.onRefresh()
  },
  computed: {},
  methods: {
    initInfo() {
      let userInfo = Vue.ls.get(WX_USER, {})
      this.realname = userInfo.wechatName
      this.userImage = userInfo.avatarUrl
      this.sysOrgCode = userInfo.sysOrgCode
      this.username = userInfo.username;
    },
    getOrgCode() {
      let params = {category: '2' }
      getAction('/sys/sysDepart/queryTreeList/by/category/xzzz', params).then((res) => {
        if (res.success) {
          let list = res.result
          this.orgCodeName = this.getNameByCode(this.sysOrgCode, list)
        }
      })
    },
    getNameByCode(code, list) {
      let xcode = code.substr(0, 3)
      let zcode = code.substr(0, 6)
      let xobj = list.find((obj) => obj.orgCode == xcode)
      let zObj = xobj.children.find((obj) => obj.orgCode == zcode)
      let cObj = zObj.children.find((obj) => obj.orgCode == code)
      let name = xobj.title + '-' + zObj.title + '-' + cObj.title
      return name
    },
    getData() {
     
      let params = { pageNo: this.pageNo, pageSize: '5',createBy:this.username}
      getAction('/zhshj/gzfwwswx/app/page', params).then((res) => {
        if (res.success) {
          if (this.refreshing) {
            this.dataList = []
            this.refreshing = false
          }
          let list = res.result.records
          this.dataList = this.dataList.concat(list)
          this.loading = false
          if (res.result.pages <= this.pageNo) {
            this.finished = true
          }
        }
      })
    },
    onLoad() {
      this.pageNo++
      this.getData()
    },
    clickSearch1() {
      this.onRefresh()
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false
      this.finishedTxt = ''
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.pageNo = 0
      this.refreshing = true
      this.onLoad()
    },
    goPublish() {
      this.$router.push({ path: '/gzfw/sqq-fb' })
    },
  },
}
</script>

<style lang="less" scoped>
// @import '../../assets/less/whon-theme.less';
.u-wrap {
  min-height: 100vh;
}
.sqq-heard {
  background: #fff;
  .home-pic {
    width: 100%;
    position: relative;
    height: 180px;
    z-index: 5;
    background: url(~@images/hmhq/bg.png);
    background-size: cover;
    margin-bottom: 25px;

    .camera {
      width: 30px;
      position: absolute;
      top: 20px;
      right: 12px;
    }
  }
  .home-pic-base {
    position: absolute;
    bottom: -24px;
    width: 100%;
    height: 65px;
    padding: 0 10px;

    .top-pic {
      width: 70px;
      height: 70px;
      border-radius: 10px;
      background-color: #ffffff;
      float: right;
      overflow: hidden;

      .header {
        width: 100%;
        height: 100%;
      }
    }

    .top-name {
      position: absolute;
      right: 90px;
      top: 9px;
      font-size: 16px;
      font-weight: 600;
      text-align: right;
      color: #ffffff;
      overflow: hidden;
    }
    .top-desc {
      position: absolute;
      right: 90px;
      bottom: 0;
      font-size: 14px;
      text-align: right;
      color: #333333;
      overflow: hidden;
    }
  }
}
</style>
